<div *ngIf="czyZaladowanoDane">
  <div class="container--main d-none d-md-block">
    <div class="ft__sort text-center pt-4">{{ dane.nazwaProjektu }}</div>

    <app-menu-projektu
      [czyPracownikKlienta]="czyPracownikKlienta()"
      [idProjektu]="idProjektu"
      [rodzajProjektu]="rodzajProjektu"
      [czyMobile]="false"
      [czyAdmin]="czyAdmin()"
      [czySpisSamodzielnyKlienta]="czySpisSamodzielnyKlienta"
      aktywnyAdres="teams"
    ></app-menu-projektu>
  </div>
  <div class="container">
    <div class="pt-3 mt-1 d-md-none">
      <div class="ft__sort text-center">{{ dane.nazwaProjektu }}</div>
    </div>

    <app-menu-projektu
      [czyPracownikKlienta]="czyPracownikKlienta()"
      [idProjektu]="idProjektu"
      [rodzajProjektu]="rodzajProjektu"
      [czyMobile]="true"
      [czyAdmin]="czyAdmin()"
      [czySpisSamodzielnyKlienta]="czySpisSamodzielnyKlienta"
      aktywnyAdres="teams"
      class="d-md-none"
    ></app-menu-projektu>

    <div class="md-white-box" *ngIf="czySaWynikiNaLiscie(dane.zespoly)">
      <button class="btn__border mb-5" (click)="dodajZespol()">
        Dodaj zespół
      </button>

      <button
        class="btn__zespol mb-3"
        *ngFor="let zespol of dane.zespoly"
        (click)="pokazSzczegoly(zespol.id)"
      >
        {{ zespol.nazwa }}
        {{ pobierzLiczbeWykonawcowZespolu(zespol.liczbaWykonawcow) }}
      </button>
    </div>
    <button
      class="btn__border mb-3 mt-3"
      (click)="dodajZespol()"
      *ngIf="!czySaWynikiNaLiscie(dane.zespoly)"
    >
      Dodaj zespół
    </button>
    <div
      class="ft__03 text-gray text-center py-5"
      style="color: #757575 !important"
      *ngIf="!czySaWynikiNaLiscie(dane.zespoly)"
    >
      Brak zapisanych<br />zespołów
    </div>
  </div>
  <div class="bootom__buttons px-4">
    <div
      class="container--mw600 flex-column flex-sm-row d-flex justify-content-between align-items-center"
    >
      <button class="btn__link order-1 order-sm-0" (click)="cofnij()">
        Cofnij
      </button>
      <button class="btn__blue order-0 order-sm-1" (click)="dalej()">
        Dalej
      </button>
    </div>
  </div>
</div>
